import React from 'react';
import { Layout, Menu, Descriptions, Typography } from 'antd';
import styles from './index.module.less';

const { Sider, Content } = Layout;
const { Item } = Menu;

export const Account = () => {
  return (
    <Layout className={styles.Account__Wrapper}>
      <Sider width={200} className={styles.Account__Sider}>
        <Typography.Title level={4} className={styles.Account__SiderTitle}>
          账号管理
        </Typography.Title>
        <Menu
          mode="inline"
          selectedKeys={['account/profile']}
        >
          <Item key="account/profile">账号信息</Item>
        </Menu>
      </Sider>
      <Content className={styles.Account__Content}>
        <Descriptions title={<Typography.Title level={4}>基本资料</Typography.Title>} column={1}>
          <Descriptions.Item label="登陆账号">xxxx</Descriptions.Item>
          <Descriptions.Item label="注册时间">xxxx</Descriptions.Item>
        </Descriptions>
        <Descriptions title={<Typography.Title level={4}>业务信息</Typography.Title>} column={1}>
          <Descriptions.Item label="桩企名称">xxxx</Descriptions.Item>
          <Descriptions.Item label="联络人">xxxx</Descriptions.Item>
          <Descriptions.Item label="联络方式">xxxx</Descriptions.Item>
          <Descriptions.Item label="所在地区">xxxx</Descriptions.Item>
          <Descriptions.Item label="注册时间">xxxx</Descriptions.Item>
          <Descriptions.Item label="测试平台账号">xxxx</Descriptions.Item>
          <Descriptions.Item label="测试平台初始密码">
            <Typography.Text copyable>xxxx</Typography.Text>
          </Descriptions.Item>
        </Descriptions>
      </Content>
    </Layout>
  );
}